const DownloadIcon = ({onClick}) => {
    return(
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} role="button">
<path d="M9.5 11.9792L9.5 4.0625M9.5 11.9792C8.94565 11.9792 7.90996 10.4003 7.52083 10M9.5 11.9792C10.0543 11.9792 11.09 10.4003 11.4792 10" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.8333 13.5625C15.8333 15.5274 15.4232 15.9375 13.4583 15.9375H5.54167C3.57675 15.9375 3.16667 15.5274 3.16667 13.5625" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
}

export default DownloadIcon